import React from "react";
import {
  Container,
  Box,
  Typography,
  Paper,
  Link,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Authenticated from "../components/Layouts/Authenticated";

/**
 * Licenses Page Component
 *
 * Displays Creative Commons license information and links.
 * Ported from MVP Licenses.jsx with Material-UI components.
 */
const Licenses: React.FC = () => {
  const theme = useTheme();

  const licenseLinks = [
    {
      title: "Creative Commons Attribution 4.0 International License",
      url: "https://creativecommons.org/licenses/by/4.0/",
    },
    {
      title:
        "Creative Commons Attribution-ShareAlike 4.0 International License",
      url: "https://creativecommons.org/licenses/by-sa/4.0/",
    },
    {
      title:
        "Creative Commons Attribution-NonCommercial 4.0 International License",
      url: "https://creativecommons.org/licenses/by-nc/4.0/",
    },
    {
      title:
        "Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License",
      url: "https://creativecommons.org/licenses/by-nc-sa/4.0/",
    },
    {
      title:
        "Creative Commons Attribution-NoDerivatives 4.0 International License",
      url: "https://creativecommons.org/licenses/by-nd/4.0/",
    },
    {
      title:
        "Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License",
      url: "https://creativecommons.org/licenses/by-nc-nd/4.0/",
    },
  ];

  return (
    <Authenticated>
      <title>Licenses - Materiom Commons</title>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 2,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: "bold",
                color: theme.palette.materiom.seaweed,
              }}
            >
              Licenses
            </Typography>
          </Box>

          <List sx={{ listStyleType: "disc", pl: 2 }}>
            {licenseLinks.map((license, index) => (
              <ListItem key={index} sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText
                  primary={
                    <Link
                      href={license.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textDecoration: "none",
                        color: theme.palette.primary.main,
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      <Typography variant="h6" component="h2">
                        {license.title}
                      </Typography>
                    </Link>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Container>
    </Authenticated>
  );
};

export default Licenses;
